import * as types from '../../constants/ActionTypes'
import { createBasicCreator, fetchData } from '../Buy'

export const normalizeSelectedServiziAggiuntivi = createBasicCreator(
  types.SERVIZI_AGGIUNTIVI_NORMALIZE_SELECTED
)

export const setSelectedServizioAggiuntivo = createBasicCreator(
  types.SERVIZI_AGGIUNTIVI_SELECTED_SERVIZIO
)

export const unSetSelectedServizioAggiuntivo = createBasicCreator(
  types.SERVIZI_AGGIUNTIVI_UNSELECTED_SERVIZIO
)

export const unSetAllServiziAggiuntivi = createBasicCreator(
  types.SERVIZI_AGGIUNTIVI_UNSELECT_ALL
)

export const getServiziAggiuntiviV1 = (dispatch, getState) => {
  const { ordine } = getState()
  const couponCode = ordine.codice_preventivo || null
  const idOrdine = ordine.id_ordine
  const uri = `${window.brumbrum.url_api}/vas/t/v1/ordini/${idOrdine}/services${
    couponCode ? `?coupon_code=${couponCode}` : ``
  }`

  return dispatch(
    fetchData(types.GET_ORDINI_SERVIZI_AGGIUNTIVI_V1)({
      callback: types.GET_ORDINI_SERVIZI_AGGIUNTIVI_V1,
      errorMessage: types.GET_ORDINI_SERVIZI_AGGIUNTIVI_V1,
      method: 'GET',
      uri,
    })
  )
}

export const putVasServiceItemsV1 = async (dispatch, getState) => {
  const order = getState().ordine
  const services = order.servizi_extra.ordini_servizi || []
  const uri = `${window.brumbrum.url_api}/vas/t/v1/ordini/${order.id_ordine}/service-items`
  const payload = JSON.stringify({
    coupon_code: order.codice_preventivo || null,
    services: services
      .map(service => {
        const s = order.servizi_aggiuntivi_disponibili.filter(
          el => el.id_servizio === service.id_servizio
        )
        return s ? s[0].id_vas : null
      })
      .filter(_ => _),
  })

  return dispatch(
    fetchData(types.PUT_VAS_SERVICE_ITEMS)({
      callback: types.PUT_VAS_SERVICE_ITEMS,
      errorMessage: types.PUT_VAS_SERVICE_ITEMS,
      method: 'PUT',
      uri,
      body: payload,
    })
  )
}

export const putOrdiniServiziAggiuntiviV1 = async (dispatch, getState) => {
  const { ordine } = getState()
  const ordini_servizi = ordine.servizi_extra.ordini_servizi || []

  const payload = { servizi_extra: { usato: [] } }

  payload.servizi_extra.usato = ordini_servizi.map(
    servizio_aggiuntivo => servizio_aggiuntivo.id_servizio
  )

  try {
    return putVasServiceItemsV1(dispatch, getState)
  } catch (error) {
    return dispatch(createBasicCreator('VAS_PUT_CATCH')({}))
  }
}
